import React from 'react';
import {lazy} from 'react';
import {Outlet} from 'react-router-dom';
// layouts
import CompactLayout from 'packages/common/layouts/compact';
import LargeLayout from 'packages/common/layouts/large';

// ----------------------------------------------------------------------

const Page403 = lazy(() => import('apps/dashboard/pages/error/view/403Page'));
const Page404 = lazy(() => import('apps/dashboard/pages/error/view/404Page'));
const Page503 = lazy(() => import('apps/dashboard/pages/error/view/503Page'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    element: (
      <CompactLayout>
        <Outlet />
      </CompactLayout>
    ),
    children: [
      {path: '403', element: <Page403 />},
      {path: '404', element: <Page404 />},
      {path: 'maintenance', element: <Page503 />},
    ],
  },
  {
    element: (
      <LargeLayout>
        <Outlet />
      </LargeLayout>
    ),
  },
];
